import { v4 as uuidv4 } from 'uuid';
import { consoleLogger } from '../logging/consoleLogger';

export const createTransactionId = () => {
  window.Utiq ||= {};
  let transactionId = window.Utiq?.transactionId;
  if (!transactionId) {
    consoleLogger.logDebug('No transaction ID present. Creating');
    transactionId = uuidv4();
    consoleLogger.logDebug(`New transactionId: ${transactionId}`);
  }

  window.Utiq ||= {};
  window.Utiq.transactionId = transactionId;
};
